import React, { useState } from "react";
import {
  Users,
  Building,
  Store,
  UserCircle,
  Tag,
  Monitor,
  Wrench,
  Pill,
  Droplets,
  Milk,
  Bot,
  Hammer,
  Upload,
  BarChart2,
  Sparkles,
  BookOpen,
  Network,
  FileText,
  Baby,
  MapPin,
  Wallet,
  Receipt,
  Radar,
  ListChecks,
  ClipboardList,
  FileCheck,
  Info,
  Briefcase,
  RefreshCw,
  Settings,
  Clock,
  Calendar,
  Newspaper,
  NotebookText,
  Cloud,
  Mail,
  Bus,
  GraduationCap,
  MessageSquare,
  Stethoscope,
} from "lucide-react";
import UserManagement from "../components/admin/UserManagement";
import CrecheTariffManagement from "../components/admin/CrecheTariffManagement";
import CrecheContractStatusManagement from "../components/admin/CrecheContractStatusManagement";
import TreasuryCategoryManagement from "../components/admin/TreasuryCategoryManagement";
import StructureManagement from "../components/admin/StructureManagement";
import SupplierManagement from "../components/admin/SupplierManagement";
import PeopleManagement from "../components/admin/PeopleManagement";
import CategoryManagement from "../components/admin/CategoryManagement";
import EquipmentCategoryManagement from "../components/admin/EquipmentCategoryManagement";
import MaintenanceTypeManagement from "../components/admin/MaintenanceTypeManagement";
import MedProductTypeManagement from "../components/admin/MedProductTypeManagement";
import WaterProductTypeManagement from "../components/admin/WaterProductTypeManagement";
import MilkBrandManagement from "../components/admin/MilkBrandManagement";
import ChildManagement from "../components/admin/ChildManagement";
import CmgBaremeManagement from "../components/admin/CmgBaremeManagement";
import StructureIdentityManagement from "../components/admin/StructureIdentityManagement";
import HRMailTemplateManagement from "../components/admin/HRMailTemplateManagement";
import HRTransportProviderManagement from "../components/admin/HRTransportProviderManagement";
import HRTrainingTypeManagement from "../components/admin/HRTrainingTypeManagement";
import HREmployeeDocumentTypeManagement from "../components/admin/HREmployeeDocumentTypeManagement";
import HROrgRoleManagement from "../components/admin/HROrgRoleManagement";
import HREmployeeInterviewTypeManagement from "../components/admin/HREmployeeInterviewTypeManagement";
import HRMedicalVisitTypeManagement from "../components/admin/HRMedicalVisitTypeManagement";
import HRMedicalVisitEmailTemplateManagement from "../components/admin/HRMedicalVisitEmailTemplateManagement";
import EmployeTemplateManagement from "../components/admin/EmployeTemplateManagement";
import OrionAgentConfig from "../components/admin/OrionAgentConfig";
import WorkOrderCategoryManagement from "../components/admin/WorkOrderCategoryManagement";
import RoomManagement from "../components/admin/RoomManagement";
import HRImportManagement from "../components/admin/HRImportManagement";
import EvaluationGridManagement from "../components/admin/EvaluationGridManagement";
import CygnusAgentConfig from "../components/admin/CygnusAgentConfig";
import CygnusKnowledgeBase from "../components/admin/CygnusKnowledgeBase";
import OrionKnowledgeBase from "../components/admin/OrionKnowledgeBase";
import AgentEcosystem from "../components/admin/AgentEcosystem";
import LyraAgentConfig from "../components/admin/LyraAgentConfig";
import LyraKnowledgeBase from "../components/admin/LyraKnowledgeBase";
import VegaAgentConfig from "../components/admin/VegaAgentConfig";
import InterviewTemplateManagement from "../components/admin/InterviewTemplateManagement";
import TimesheetMotifManagement from "../components/admin/TimesheetMotifManagement";
import CalendarCategoryManagement from "../components/admin/CalendarCategoryManagement";
import GazetteSectionTypeManagement from "../components/admin/GazetteSectionTypeManagement";
import CommunicationSettingsAdmin from "../components/admin/CommunicationSettingsAdmin";
import RecruitmentPositionManagement from "../components/admin/RecruitmentPositionManagement";
import FamilyDocumentTypeManagement from "../components/admin/FamilyDocumentTypeManagement";
import NovaConfig from "../components/admin/NovaConfig";
import TechnicalReferential from "../components/admin/TechnicalReferential";
import MeekoChildrenSync from "../components/admin/MeekoChildrenSync";
import MeekoConfig from "../components/admin/MeekoConfig";

const groups = [
  {
    label: "Général",
    items: [
      {
        id: "users",
        label: "Utilisateurs",
        icon: Users,
        component: UserManagement,
      },
      {
        id: "structures",
        label: "Structures",
        icon: Building,
        component: StructureManagement,
      },
      {
        id: "suppliers",
        label: "Fournisseurs",
        icon: Store,
        component: SupplierManagement,
      },
      {
        id: "people",
        label: "Personnes",
        icon: UserCircle,
        component: PeopleManagement,
      },
    ],
  },
  {
    label: "Stocks",
    items: [
      {
        id: "categories",
        label: "Catégories produits",
        icon: Tag,
        component: CategoryManagement,
      },
    ],
  },
  {
    label: "Infrastructure",
    items: [
      {
        id: "equipmentCategories",
        label: "Catégories équipements",
        icon: Monitor,
        component: EquipmentCategoryManagement,
      },
      {
        id: "maintenanceTypes",
        label: "Types maintenance",
        icon: Wrench,
        component: MaintenanceTypeManagement,
      },
      {
        id: "workOrderCategories",
        label: "Catégories travaux",
        icon: Hammer,
        component: WorkOrderCategoryManagement,
      },
      {
        id: "rooms",
        label: "Pièces / Lieux",
        icon: MapPin,
        component: RoomManagement,
      },
    ],
  },
  {
    label: "Trésorerie",
    items: [
      {
        id: "treasuryCategories",
        label: "Catégories trésorerie",
        icon: Wallet,
        component: TreasuryCategoryManagement,
      },
    ],
  },
  {
    label: "Crèche",
    items: [
      {
        id: "crecheTariffs",
        label: "Tarifs crèche",
        icon: Receipt,
        component: CrecheTariffManagement,
      },
      {
        id: "crecheStatuses",
        label: "Statuts contrat",
        icon: ListChecks,
        component: CrecheContractStatusManagement,
      },
      {
        id: "children",
        label: "Enfants",
        icon: Baby,
        component: ChildManagement,
      },
      {
        id: "cmgBaremes",
        label: "Baremes CMG",
        icon: Wallet,
        component: CmgBaremeManagement,
      },
      {
        id: "familyDocTypes",
        label: "Types documents familles",
        icon: FileCheck,
        component: FamilyDocumentTypeManagement,
      },
    ],
  },
  {
    label: "Traçabilités",
    items: [
      {
        id: "milkBrands",
        label: "Marques lait",
        icon: Milk,
        component: MilkBrandManagement,
      },
      {
        id: "medTypes",
        label: "Types médicaments",
        icon: Pill,
        component: MedProductTypeManagement,
      },
      {
        id: "waterTypes",
        label: "Types eau",
        icon: Droplets,
        component: WaterProductTypeManagement,
      },
    ],
  },
  {
    label: "Agents IA",
    items: [
      {
        id: "agentEcosystem",
        label: "Écosystème",
        icon: Network,
        component: AgentEcosystem,
      },
      {
        id: "novaConfig",
        label: "Nova — Visibilité",
        icon: Network,
        component: NovaConfig,
      },
      {
        id: "cygnusConfig",
        label: "Cygnus — Configuration",
        icon: Sparkles,
        component: CygnusAgentConfig,
      },
      {
        id: "cygnusKnowledge",
        label: "Cygnus — Connaissance",
        icon: BookOpen,
        component: CygnusKnowledgeBase,
      },
      {
        id: "orionConfig",
        label: "Orion — Configuration",
        icon: Bot,
        component: OrionAgentConfig,
      },
      {
        id: "orionKnowledge",
        label: "Orion — Connaissance",
        icon: BookOpen,
        component: OrionKnowledgeBase,
      },
      {
        id: "lyraConfig",
        label: "Lyra — Configuration",
        icon: FileText,
        component: LyraAgentConfig,
      },
      {
        id: "lyraKnowledge",
        label: "Lyra — Connaissance",
        icon: BookOpen,
        component: LyraKnowledgeBase,
      },
      {
        id: "vegaConfig",
        label: "VEGA — Configuration",
        icon: Radar,
        component: VegaAgentConfig,
      },
      {
        id: "siriusConfig",
        label: "Sirius — Communication",
        icon: Sparkles,
        component: CommunicationSettingsAdmin,
      },
    ],
  },
  {
    label: "Ressources humaines",
    items: [
      {
        id: "structureIdentity",
        label: "Identité structures",
        icon: Building,
        component: StructureIdentityManagement,
      },
      {
        id: "mailTemplates",
        label: "Templates mail",
        icon: Mail,
        component: HRMailTemplateManagement,
      },
      {
        id: "evaluationGrids",
        label: "Grilles d'évaluation",
        icon: BarChart2,
        component: EvaluationGridManagement,
      },
      {
        id: "hrImport",
        label: "Import données RH",
        icon: Upload,
        component: HRImportManagement,
      },
      {
        id: "timesheetMotifs",
        label: "Motifs feuille de temps",
        icon: Clock,
        component: TimesheetMotifManagement,
      },
      {
        id: "orgRoles",
        label: "Rôles organigramme",
        icon: Network,
        component: HROrgRoleManagement,
      },
      {
        id: "transportProviders",
        label: "Fournisseurs transport",
        icon: Bus,
        component: HRTransportProviderManagement,
      },
      {
        id: "trainingTypes",
        label: "Types de formation",
        icon: GraduationCap,
        component: HRTrainingTypeManagement,
      },
      {
        id: "employeeInterviewTypes",
        label: "Types d'entretien employé",
        icon: MessageSquare,
        component: HREmployeeInterviewTypeManagement,
      },
      {
        id: "medicalVisitTypes",
        label: "Types de visite médicale",
        icon: Stethoscope,
        component: HRMedicalVisitTypeManagement,
      },
      {
        id: "employeeDocumentTypes",
        label: "Types de documents employé",
        icon: FileText,
        component: HREmployeeDocumentTypeManagement,
      },
      {
        id: "medicalVisitEmailTemplates",
        label: "Templates mail visites médicales",
        icon: Mail,
        component: HRMedicalVisitEmailTemplateManagement,
      },
      {
        id: "employeeInterviewTemplates",
        label: "Templates entretien employé",
        icon: ClipboardList,
        component: EmployeTemplateManagement,
      },
    ],
  },
  {
    label: "Recrutement",
    items: [
      {
        id: "recruitmentPositions",
        label: "Postes",
        icon: Briefcase,
        component: RecruitmentPositionManagement,
      },
      {
        id: "interviewTemplates",
        label: "Templates entretiens",
        icon: ClipboardList,
        component: InterviewTemplateManagement,
      },
    ],
  },
  {
    label: "Meeko",
    items: [
      {
        id: "meekoConfig",
        label: "Configuration",
        icon: Settings,
        component: MeekoConfig,
      },
      {
        id: "meekoChildren",
        label: "Enfants",
        icon: RefreshCw,
        component: MeekoChildrenSync,
      },
    ],
  },
  {
    label: "Communication",
    items: [
      {
        id: "gazetteSectionTypes",
        label: "Sections gazette",
        icon: Newspaper,
        component: GazetteSectionTypeManagement,
      },
    ],
  },
  {
    label: "Outils",
    items: [
      {
        id: "calendarCategories",
        label: "Catégories calendrier",
        icon: Calendar,
        component: CalendarCategoryManagement,
      },
      {
        id: "referential",
        label: "Referentiel technique",
        icon: Info,
        component: TechnicalReferential,
      },
    ],
  },
];

const allTabs = groups.flatMap((g) => g.items);

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState("users");

  const ActiveComponent = allTabs.find(
    (tab) => tab.id === activeTab,
  )?.component;

  return (
    <div className="min-h-full flex flex-col sm:flex-row bg-gray-50">
      {/* Mobile: select */}
      <div className="sm:hidden w-full bg-white border-b border-gray-200 px-4 py-3 flex-shrink-0 self-start">
        <select
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
        >
          {groups.map((group) => (
            <optgroup key={group.label} label={group.label}>
              {group.items.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      {/* Desktop: left sidebar */}
      <aside className="hidden sm:block w-52 flex-shrink-0 bg-white border-r border-gray-200 sticky top-0 h-screen overflow-y-auto">
        <nav className="py-3 pb-16">
          {groups.map((group) => (
            <div key={group.label} className="mb-3">
              <div className="px-4 py-1 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                {group.label}
              </div>
              {group.items.map((item) => {
                const Icon = item.icon;
                const isActive = activeTab === item.id;
                return (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`w-full flex items-center gap-2.5 px-4 py-2 text-sm font-medium transition-colors text-left ${
                      isActive
                        ? "bg-primary/10 text-primary border-r-2 border-primary"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    }`}
                  >
                    <Icon size={16} className="flex-shrink-0" />
                    <span className="truncate">{item.label}</span>
                  </button>
                );
              })}
            </div>
          ))}
        </nav>
      </aside>

      {/* Content */}
      <main className="flex-1 min-w-0 py-6">
        {ActiveComponent && <ActiveComponent />}
      </main>
    </div>
  );
};

export default AdminPage;
